/**
 * Docket entry Dashboard
 */
import { axiosRequest } from '@/plugins/axios-common'
import { handleError } from '@/store/handle-error'

export const DashboardState = {}

export const DashboardActions = {
  dashboardDocketEntries: async (_, requestData) => {
    return axiosRequest.
      get('/dashboard_docket_entries', { params: requestData }).
      then(({ data }) => data || {}).
      catch(handleError)
  },
}

export const DashboardMutations = {}

export const DashboardGetters = {}
